import { AnswerDto } from 'entities/answer.dto';
import React from 'react';

type Props = {
	answers: AnswerDto[];
};

export const AnswersTab: React.FC<Props> = ({ answers }) => {
	return (
		<>
			{answers.length === 0 && (
				<div className='text-gray-500 text-sm'>
					Brak pytań na które udzielono odpowiedzi
				</div>
			)}
			{answers.map((el: any, i: Number) => {
				return (
					<>
						<div
							className='my-2 w-3/4 text-sm rounded-lg p-4 bg-gray-200'
							key={`${i}`}
						>
							<i>{el.question.content}</i>
						</div>
						<div className='flex justify-end gap-2'>
							<div
								className='my-2 w-3/4 text-sm rounded-lg p-4 bg-blue-200'
								key={`${i}`}
							>
								<i>{el.content}</i>
							</div>
						</div>
					</>
				);
			})}
		</>
	);
};
